import * as firebase from 'firebase/app';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyAmA5ULucmPuQUu5st1QYsnG9fnp-cDYPY',
  authDomain: 'calgaro-formulario.firebaseapp.com',
  databaseURL: 'https://calgaro-formulario.firebaseio.com',
  projectId: 'calgaro-formulario',
  storageBucket: 'calgaro-formulario.appspot.com',
  messagingSenderId: '912688378082',
  appId: '1:912688378082:web:6106bb68f56e3fa017aebb',
  measurementId: 'G-X16KRKFHJ9',
};
// Initialize Firebase
export const app = firebase.initializeApp(firebaseConfig);
